export const DataHooks = {
  Root: 'PaymentMethodsList.Root',
  Item: (idx?: number) => `PaymentMethodsList.Item-${idx ?? ''}`,
} as const;
